import { Navigate, useLocation } from 'react-router-dom'

import { IRoleEnum } from '../../types/router'
import { hasPermission } from '../../utils/auth'
import NoAccess from '../NoAccess/NoAccess'

interface IRequireAuthProps {
    children: JSX.Element
    roles: IRoleEnum[]
}

const RequireAuth = (props: IRequireAuthProps) => {
    const { children, roles } = props

    const location = useLocation()

    const accessToken = localStorage.getItem('accessToken')

    return accessToken ? (
        hasPermission(roles) ? (
            children
        ) : (
            <NoAccess />
        )
    ) : (
        <Navigate to="/login" state={{ from: location }} replace />
    )
}

export default RequireAuth
